import { render, staticRenderFns } from "./ItemQuestion.vue?vue&type=template&id=1a38541a&"
import script from "./ItemQuestion.vue?vue&type=script&lang=js&"
export * from "./ItemQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\DIA-funsporthandel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a38541a')) {
      api.createRecord('1a38541a', component.options)
    } else {
      api.reload('1a38541a', component.options)
    }
    module.hot.accept("./ItemQuestion.vue?vue&type=template&id=1a38541a&", function () {
      api.rerender('1a38541a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/ItemQuestion.vue"
export default component.exports